const HANDLER_DELAY = 3;

const eipHandler = (config) => {
    setTimeout(() => {
        const e = {
            target: {
                innerText: 'EIP proactive',
                dataset: {
                    userevent: 'widgetPopupGet',
                    attributesToSend: 'queue,disableLaunch,opis',
                    queue: config.eipOptions.gweInviteOptions.queue,
                    opis: config.eipOptions.gweInviteOptions.description,
                    disableLaunch: true
                }
            }
        };

        window.WC.config.eip = {
            defaultView: '',
            eipView: 'cmbPopup',
            eipOptions: {
                ...config.eipOptions
            }
        };

        if (!window.OPLWCParent) {
            document.addEventListener('WCCParentLoaded', () => {
                window.OPLWCParent.genesysButtonHandler(e);
            });
        } else {
            window.OPLWCParent.genesysButtonHandler(e);
        }
    }, HANDLER_DELAY * 1000);
};

export { eipHandler };
